<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" color="green" size="18" class="ml-1" v-show="showIcon">
        mdi-cash-fast
      </v-icon>
    </template>
    <span>
      {{ $t("cashoutAvailable") }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["show"],
  data: () => ({
    showIcon: false,
  }),
  created() {
    this.showIcon = this.show && this.$isCreditOnline() && !this.$isAgent();
  },
};
</script>
